// src/components/RouteWithLoading.js
import React, { useState, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import Loading from './Loading';

const RouteWithLoading = ({ component: Component, ...rest }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && <Loading />}
      <Route {...rest} render={(props) => <Component {...props} />} />
    </>
  );
};

export default RouteWithLoading;
